import { assign, isPlainObject } from 'lodash';

import { resolve } from 'gear';

import { g$ } from '../view';

import { Canvas3D } from './canvas3d';

let canvas3D = null;

function _thumbnailImage$( config ) {

  const size = ( config.size === undefined ) ? 256 : config.size;

  if( ! canvas3D ) {
    canvas3D = new Canvas3D({ width: size, height: size, preserveDrawingBuffer: true, autoDraw: false });
  }
  else if( canvas3D.width !== size ) {
    canvas3D.updateSize(size,size);
  }

  if( config.canvas3D ) {
    // Copy camera position from the user view
    canvas3D.cameraStateString = config.canvas3D.cameraStateString;
  }

  return canvas3D.showDocument$( config.document ) .then( () => {
  return canvas3D.draw$() .then( () => {
  return canvas3D.image();

  }); });
}

let currentPromise = resolve();

export const thumbnailImage3D$ = function( config ) {
  currentPromise = currentPromise.then( () => {
  return _thumbnailImage$(config);
  });
  return currentPromise;
};


// Cx.Preview3D({ renderTo: ..., id: ... });

export const Preview3D = Canvas3D.extend({

  init( config = {} ) {

    this.callParent(config);

    if( config.id ) {
      this.load$(config.id) .then( this.commit$ );
    }
  }
});

export function createPreview3D( domId, docId, a ) {
  const config = { appendTo: g$('#'+domId), id: docId };
  if( isPlainObject(a) ) {
    assign(config,a);
  }
  else if( a ) {
    config.documentFilter = a;
  }
  return Preview3D(config);
}



/** WEBPACK FOOTER **
 ** ./src/ui/canvas3d/thumbnail.js
 **/